<template>
  <div id="content">
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <router-link
              :to="{ name: moduleName }"
              class="btn btn_back"
              v-translate>Seznam
          </router-link>
        </p>
        <h1 v-translate>Přidat Brand</h1>
      </div>
      <div class="responsiveTabs r-tabs">
        <ul class="tabs">
          <li :class="getActiveTabClass('settings')">
            <a @click.prevent.stop="activateTab('settings')" v-translate>Vlastnosti</a>
          </li>
          <li :class="getActiveTabClass('liveweb')">
            <a @click.prevent.stop="activateTab('liveweb')" v-translate>Nastavení LiveWebu</a>
          </li>
        </ul>
        <div class="tabs_content" v-show="isActiveTab('settings')">
          <BasicInfo :entity="entity" :is-editable="true" ref="basicinforef" />
          <ShopUrls :entity="entity"  :is-editable="true" ref="shopurlref" />
          <QrCodePairing :entity="entity" :is-editable="true" ref="qrcodepairingref" />
        </div>
        <div class="tabs_content" v-show="isActiveTab('liveweb')">
          <LivewebSettings :entity="entity" :is-editable="true" ref="livewebref" />
        </div>

        <section class="buttons">
          <p>
            <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam</router-link>
            <input
              type="submit"
              :value="'Uložit' | translate"
              :class="['btn', { btn_inactive: !formIsValid }]"
              @click.prevent.stop="createEntity()">
          </p>
        </section>
      </div>
    </form>
  </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions"
import brands from "@/components/views/brands/mixins/brands"
import BasicInfo from "./forms/BasicInfo";
import ShopUrls from "./forms/ShopUrls";
import LivewebSettings from "./forms/LivewebSettings";
import QrCodePairing from "./forms/QrCodePairing.vue";

export default {
  name: "BrandNew",
  components: {
    LivewebSettings,
    ShopUrls,
    BasicInfo,
    QrCodePairing,
  },
  mixins: [detailActions, brands],
  mounted() {
    this.activateTab("settings");
  },
  data() {
    return {
      getSelectedOperatorAfterLoad: true,
      entity: null,
    }
  },
  created(BrandService) {
    this.entityService = BrandService

    this.entity = {
      name: '',
      code: '',
      apple_store_url: null,
      google_store_url: null,
      microsoft_store_url: null,
      note: null,
      allow_pair_devices_from_other_brands_when_static_brand_configured: false,
      liveweb_settings: {
        site_title: '',
        hide_sections: [],
        automatic_pairing: false,
        pair_by_pairing_code: false,
        client_zone_url: '',
        logout_url: '',
        alternative_login_screen_html: '',
        custom_login_screen_html: '',
        automatic_pairing_error_message_html: '',
        non_updatable_device_type_codes: [],
        non_deletable_device_type_codes: [],
        custom_links: [],
      }
    };
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/brands/BrandNew.vue